import FolderCopyOutlined from "@mui/icons-material/FolderCopyOutlined";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { Column } from "../../components/dataTable/dataTable";
import { AppRoutes } from "../../constants";
import { INGO_V2 } from "../../types";
import { mobileText } from "../../utils/responsiveStyle";

export const orgNgoColumns = (
  categoryMap: Map<string, string> = new Map(),
  cityMap: Map<string, string> = new Map(),
  openImageModal?: (url: string, title: string) => void,
  navigate?: (path: string) => void,
): Column<INGO_V2>[] => {
  return [
    // {
    //   key: "logo",
    //   label: "Logo",
    //   minWidth: 120,
    //   render: (ngo) => (
    //     <img
    //       src={ngo.logo?.url || "/placeholder-logo.png"}
    //       alt={ngo.name}
    //       style={{
    //         width: "100%",
    //         maxWidth: 80,
    //         maxHeight: 50,
    //         objectFit: "contain",
    //         borderRadius: 8,
    //         border: "1px solid #ddd",
    //       }}
    //     />
    //   ),
    // },

    {
      key: "name",
      label: "Name",
      minWidth: 150,
      render: (ngo) => <strong>{ngo.name}</strong>,
    },
    // {
    //   key: "tagline",
    //   label: "Tagline",
    //   minWidth: 120,
    //   render: (ngo) => ngo.tagline || "-",
    // },
    {
      key: "category",
      label: "Category",
      minWidth: 120,
      render: (ngo) => {
        const categoryId =
          typeof ngo.category === "string" ? ngo.category : ngo.category?.name;

        const categoryName = categoryId ? categoryMap.get(categoryId) : "-";

        return (
          <Tooltip title={categoryName || "-"} arrow>
            <Typography
              noWrap
              sx={{
                maxWidth: 120,
                overflow: "hidden",
                textOverflow: "ellipsis",
                ...mobileText,
              }}
            >
              {categoryName || ""}
            </Typography>
          </Tooltip>
        );
      },
    },

    // {
    //   key: "cities",
    //   label: "Cities",
    //   minWidth: 120,
    //   render: (ngo) => {
    //     if (!ngo.cities?.length) return "-";
    //     const names = ngo.cities
    //       .map((id) => cityMap.get(id))
    //       .filter(Boolean)
    //       .join(", ");
    //     return names || `${ngo.cities.length} cities`;
    //   },
    // },

    {
      key: "email",
      label: "Email",
      minWidth: 120,
      render: (ngo) => ngo.email || "-",
    },

    {
      key: "websiteUrl",
      label: "Website",
      minWidth: 120,
      render: (ngo) =>
        ngo.websiteUrl ? (
          <a
            style={{ whiteSpace: "nowrap" }}
            href={ngo.websiteUrl}
            target="_blank"
            rel="noreferrer"
          >
            Visit Website
          </a>
        ) : (
          "-"
        ),
    },

    {
      key: "darpanId",
      label: "Darpan ID",
      minWidth: 120,
      render: (ngo) => ngo.darpanId || "-",
    },

    {
      key: "eightyGCertificate",
      label: "80G Certificate",
      minWidth: 50,
      align: "center",
      render: (ngo) =>
        ngo.eightyGCertificate?.url ? (
          <IconButton
            size="small"
            onClick={() =>
              openImageModal?.(ngo.eightyGCertificate!.url, "80G Certificate")
            }
            title="View 80G Certificate"
          >
            <VisibilityOutlined fontSize="small" />
          </IconButton>
        ) : (
          "-"
        ),
    },

    {
      key: "trustDeedCertificate",
      label: "Trust Deed",
      minWidth: 50,
      align: "center",
      render: (ngo) =>
        ngo.trustDeedCertificate?.url ? (
          <IconButton
            size="small"
            onClick={() =>
              openImageModal?.(
                ngo.trustDeedCertificate!.url,
                "Trust Deed Certificate",
              )
            }
            title="View Trust Deed"
          >
            <VisibilityOutlined fontSize="small" />
          </IconButton>
        ) : (
          "-"
        ),
    },
    {
      key: "projects",
      label: "Projects",
      minWidth: 50,
      align: "center",
      render: (ngo) =>
        ngo.projects ? (
          <IconButton
            size="small"
            onClick={() => {
              navigate?.(
                `${AppRoutes.ORGANIZATION.PROJECTS.LIST}?ngoId=${ngo._id}`,
              );
            }}
            title="View Projects"
          >
            <FolderCopyOutlined fontSize="small" />
          </IconButton>
        ) : (
          "-"
        ),
    },

    {
      key: "actions",
      minWidth: 120,
      label: "Actions",
      align: "center",
    },
  ];
};
